module.exports = __webpack_public_path__ + "static/media/finland-cover.a5473741.jpg";